import 'css-chunksrc/client/scenes/preferences/calendar/loader/styles.scss';export default {
  "loader": "_loader_u0bof_1",
  "caseCalendar": "_caseCalendar_u0bof_7",
  "hideElement": "_hideElement_u0bof_26",
  "loadingBar": "_loadingBar_u0bof_31"
};